// Sync accessToken vào IndexedDB cho Service Worker đọc khi handle inline reply
// (Chrome desktop chat noti). SW KHÔNG access được localStorage — phải qua IndexedDB.

const DB_NAME = 'cnvwork-sw';
const STORE = 'auth';
const KEY = 'accessToken';

function openDB() {
  return new Promise((resolve, reject) => {
    if (!('indexedDB' in window)) return reject(new Error('no_indexeddb'));
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function writeToken(token) {
  try {
    const db = await openDB();
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).put(token, KEY);
      tx.oncomplete = resolve;
      tx.onerror = () => reject(tx.error);
    });
  } catch { /* best-effort */ }
}

export async function clearToken() {
  try {
    const db = await openDB();
    await new Promise((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).delete(KEY);
      tx.oncomplete = resolve;
      tx.onerror = () => reject(tx.error);
    });
  } catch { /* best-effort */ }
}

/**
 * Subscribe vào Zustand authStore — mỗi khi accessToken thay đổi, sync IndexedDB.
 */
export function setupTokenSync(useAuthStore) {
  // Initial: write current token nếu có
  const initialToken = useAuthStore.getState().accessToken;
  if (initialToken) writeToken(initialToken);

  return useAuthStore.subscribe((state, prev) => {
    if (state.accessToken === prev.accessToken) return;
    if (state.accessToken) writeToken(state.accessToken);
    else clearToken();
  });
}
